import { render, staticRenderFns } from "./VluForm.vue?vue&type=template&id=2c3b452f&scoped=true"
import script from "./VluForm.vue?vue&type=script&lang=js"
export * from "./VluForm.vue?vue&type=script&lang=js"
import style0 from "./VluForm.vue?vue&type=style&index=0&id=2c3b452f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b452f",
  null
  
)

export default component.exports